import type { JSX } from "react";

import { Badge } from "@/components/ui/badge";

/**
 * Renders the "count failed to load" indicator — identical markup for
 * every nav item that has one (knowledge, quality) — plus its sr-only echo.
 */
export function NavBadgeError({ title, srText }: { title: string; srText: string }): JSX.Element {
  return (
    <>
      <Badge
        variant="muted"
        className="ml-1.5 h-4 min-w-[1rem] justify-center px-1 py-0 text-label-3"
        title={title}
        aria-hidden="true"
      >
        ?
      </Badge>
      <span className="sr-only">{srText}</span>
    </>
  );
}
